module.exports = __webpack_public_path__ + "assets/img/folder-open.5f5ab6eb.svg";